import BaseModel from 'models/base-model';

export default class Country extends BaseModel({
  geoCode: '',
  description: null,
  memberFirmCode: '',
  countryCode: '',
  countryName: '',
  containerId: null,
  containerCode: '',
  containerName: '',
}) {}
